export { default as PlayerInfo } from './PlayerInfo';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/PlayerInfo/index.ts